import { useNavigate } from 'react-router-dom';
import { Grid, Button, TextField, Box } from '@mui/material';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { useState } from 'react';
import { useSaveData } from '../../../hooks/useSaveData';
import FormInput from '../../query-builder/hooks-form-querybuilder/form-input.component';

interface ActionPage {
  isLoading: boolean;
  page: string;
  requestID?: any;
  isRequestType?: boolean;
  handleCancel: () => void;
  handleSubmit: (data: any) => any;
}

const styling = {
  root: { paddingRight: '15px', paddingBottom: '10px' },
  buttonStyle: { width: '130px', marginLeft: '10px' },
};

export const FormButtons = ({ isLoading, page, requestID, isRequestType, handleCancel, handleSubmit }: ActionPage) => {
  const navigate = useNavigate();
  const [statusValue, setStatusValue] = useState<number>(0);
  const [requestComment, setRequestComment] = useState<string>('');

  const { isLoading: isUpdateRequestLoading, mutateAsync } = useSaveData<any>(
    projectsApiKeyStore.updateProjectRequestStatus()
  );

  const onCancel = () => {
    handleCancel();
    // navigate(`/customers/details/${customerID}`);
  };

  const handleStatusDropdwon = (value: any) => {
    setStatusValue(value ?? 0);
  };

  const updateRequestStatusControll = async () => {
    const statusPayload = {
      requestID: Number(requestID),
      reqStatusID: statusValue,
      requestComment,
    };

    await mutateAsync({ data: statusPayload });
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container justifyContent="space-between" spacing={1}>
      <Grid item>
        <Button variant="outlined" style={styling.buttonStyle} onClick={onCancel}>
          Cancel
        </Button>
      </Grid>
      {page == 'edit' ? (
        <Grid item>
          <Grid
            container
            direction="row"
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            {isRequestType && (
              <>
                <FormSelectDynamic
                  name="reqStatusID"
                  label="Request Status"
                  onChange={handleStatusDropdwon}
                  disabled={isUpdateRequestLoading}
                  getQueryKeyConfig={() => projectsApiKeyStore.getProjectRequestStatus()}
                  optionsValueKey="reqStatusID"
                  optionsLabelKeys={['reqStatus']}
                />
                <TextField
                  name="requestComment"
                  multiline
                  rows={3}
                  placeholder="request comment"
                  value={requestComment}
                  onChange={(e) => setRequestComment(e.target.value)}
                  disabled={isUpdateRequestLoading}
                  style={{ marginLeft: '10px', width: '300px' }}
                  size="small"
                />
                {statusValue != 2 && statusValue != 0 && (
                  <Button
                    type={'button'}
                    disabled={isLoading || isReadOnlyPermission || isUpdateRequestLoading}
                    variant="contained"
                    disableElevation={true}
                    style={styling.buttonStyle}
                    onClick={updateRequestStatusControll}
                  >
                    Save
                  </Button>
                )}
              </>
            )}
            {(statusValue == 2 || statusValue == 0) && (
              <>
                <Button
                  type={'button'}
                  disabled={isLoading || isReadOnlyPermission}
                  variant="contained"
                  disableElevation={true}
                  style={{
                    color: 'white',
                    marginLeft: '10px',
                    backgroundColor: isLoading || isReadOnlyPermission ? '#9F9FA9' : '#e67e22',
                    width: '250px',
                  }}
                  onClick={() => handleSubmit('without-workorder')}
                >
                  Save Without Workorder
                </Button>
                <Button
                  type={'button'}
                  disabled={isLoading || isReadOnlyPermission}
                  variant="contained"
                  disableElevation={true}
                  style={{
                    color: 'white',
                    backgroundColor: isLoading || isReadOnlyPermission ? '#9F9FA9' : '#239b56',
                    width: '250px',
                    marginLeft: 10,
                  }}
                  onClick={() => handleSubmit('with-workorder')}
                >
                  Save with workorder
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid item>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              }}
            >
              {isRequestType && (
                <>
                  <FormSelectDynamic
                    name="reqStatusID"
                    label="Request Status"
                    onChange={handleStatusDropdwon}
                    disabled={isUpdateRequestLoading}
                    getQueryKeyConfig={() => projectsApiKeyStore.getProjectRequestStatus()}
                    optionsValueKey="reqStatusID"
                    optionsLabelKeys={['reqStatus']}
                  />

                  {/* <FormInput className="m-5" name="description" label="Description" multiline size={6.0} /> */}

                  <Box sx={{ ml: '10px', width: '280px', flexShrink: 0 }}>
                    <FormInput name="mySIRequestComment" label="Comments" multiline size={3} />
                  </Box>
                </>
              )}

              <Grid item>
                <Button
                  type={'button'}
                  disabled={isLoading || isReadOnlyPermission}
                  variant="contained"
                  disableElevation={true}
                  style={styling.buttonStyle}
                  onClick={() => handleSubmit('without-workorder')}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
